import { any, fromJSX, stateful } from "widgets-for-react";
import { closeDialogById } from "../../../../Shared/pollyfill/HTMLDialogElement";
import { searchModalId, SearchModalLayout } from "./searchModalLayout";
import { initialState } from "./searchModalState";
import { useHistory } from "react-router";
export const SearchModalWidget = (props)=>{
    const history = useHistory();
    return stateful({
        key: 'recent_news_block'
    })((s0)=>any()([
            fromJSX((setState)=>SearchModalLayout({
                    ...s0,
                    ...props,
                    updateQuery: (searchQuery)=>setState((s0)=>({
                                ...s0,
                                searchQuery
                            })),
                    runSearch: ()=>{
                        history.push("/zoeken?q=" + encodeURIComponent(s0.searchQuery));
                        closeDialogById(searchModalId);
                        props.runNewQuery(s0.searchQuery);
                        setState((_)=>({
                                ...initialState
                            }));
                    }
                }))
        ]).map((a)=>a(s0)))(initialState);
};
